import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { ROUTES } from '@/constants/routes'
import { getAuthToken } from '@/utils/auth'

/**
 * Protects routes when using legacy email/password auth. Redirects to login if no token.
 */
export default function LegacyRequireAuth() {
  const location = useLocation()
  const token = getAuthToken()

  if (!token) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  return <Outlet />
}
